import React from 'react';
import './BubbleTracker.scss'

let BubbleTracker = ({total,current}) =>{
    return(
        <div className={'BubbleTracker'}>
            {total && 
                [...Array(total)].map((item,i)=>{
                        return(
                            <div key={`circle-${i}`} className={`circle  ${current >= i&& "filledCircle"}`}></div>
                        )
                })}
        </div>
    )
}

export default BubbleTracker